module.exports = __webpack_public_path__ + "img/borderRightArrowWhite.a52e2d11.svg";